module.exports = __webpack_public_path__ + "img/VU.8ea93421.png";